import {
  AreaChart as RechartsAreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { CHART_THEME, chartTooltipStyle, formatChartCurrency } from './chartTheme';

interface AreaChartProps {
  data: Record<string, string | number>[];
  xKey: string;
  yKey: string;
  color?: string;
  height?: number;
  valueFormatter?: (value: number) => string;
}

function AreaChart({
  data,
  xKey,
  yKey,
  color = CHART_THEME.cashFlow,
  height = 240,
  valueFormatter = formatChartCurrency,
}: AreaChartProps) {
  const gradientId = `zt-area-${yKey}`;

  return (
    <ResponsiveContainer width="100%" height={height}>
      <RechartsAreaChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
        <defs>
          <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor={color} stopOpacity={0.35} />
            <stop offset="95%" stopColor={color} stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke={CHART_THEME.grid} vertical={false} />
        <XAxis
          dataKey={xKey}
          tick={{ fill: CHART_THEME.axis, fontSize: 11 }}
          axisLine={{ stroke: CHART_THEME.grid }}
          tickLine={false}
        />
        <YAxis
          tick={{ fill: CHART_THEME.axis, fontSize: 11 }}
          axisLine={false}
          tickLine={false}
          tickFormatter={valueFormatter}
          width={56}
        />
        <Tooltip
          contentStyle={chartTooltipStyle}
          formatter={(value: number) => valueFormatter(value)}
        />
        <Area
          type="monotone"
          dataKey={yKey}
          stroke={color}
          strokeWidth={2}
          fill={`url(#${gradientId})`}
          animationDuration={700}
        />
      </RechartsAreaChart>
    </ResponsiveContainer>
  );
}

export default AreaChart;
